var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header",class:{ isPC: _vm.$store.getters['camera/isPC'] }},[_c('h1',{staticClass:"page-header-title"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('componentsPageHeader.header')))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }